import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import State from "../../ducks/state"
import {REALM_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {isImagePlaceholderEnabled} = state.secondarynav
    const department = state.primarynav.activeDepartment
    const {testingVariant} = state?.secondarynav?.catalogues[department] || ""
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const {siteUrl} = state.request
    const {variant, iconsVersionPath} = state.settings

    return {
        isImagePlaceholderEnabled,
        realm,
        testingVariant,
        siteUrl,
        templating: state.template,
        variant,
        iconsVersionPath,
        text: {chevronIconAltText: state.text.catalogueList.chevronIconAltText},
    }
}

export default connect(mapStateToProps)
